/**
 * ChosenProductCategoryWatcher is used on product edit pages,
 * and watches the product category field. When it changes, it
 * sends a CustomEvent `terrahub-product-category-set` to the document.
 */
export class ChosenProductCategoryWatcher {
	constructor() {
		const chosen_product_cat = document.querySelector(`input[name="chosen_product_cat[]"`);
		if (!chosen_product_cat) {
			return;
		}
		this.setProductCat(parseInt(chosen_product_cat.value));

		wp.hooks.addAction(
		    'dokan_selected_multistep_category', 
		    'dokan-multistep-category', 
		    categoryId => this.setProductCat(categoryId)
		);
	}
	setProductCat(categoryId) {
		console.log(`set categoryId = ${categoryId}`);
		document.dispatchEvent(new CustomEvent(`terrahub-product-category-set`, {
			bubbles: true,
			cancelable: true,
			composed: true,
			detail: {
				product_category_id: categoryId,
			}
		}));
	}
}